import { App } from './App';
import { getConfiguration, renderRootElement } from '~/utils';

export const render = async (rootElement: HTMLElement, isECatalogue: boolean) => {
  const configuration = getConfiguration(rootElement);
  const props = { configuration, isECatalogue };
  await renderRootElement(rootElement, <App {...props} />);

  return true;
};
